import React, { useState } from "react"

import { AlertMessageBox } from "~tailwindui/Basics"

import classNames from "src/classNames"
import { findGeminiLanguage } from "src/geminiLanguageOptions"

import { gql, useMutation } from "hooks/urql"

type SetTranslationLanguageProps = {
  studentSessionId: string
  defaultLanguageCode: string
  liveTranslationEnabled: boolean
  disabled: boolean
}

const SetTranslationLanguage: React.FC<SetTranslationLanguageProps> = ({
  studentSessionId,
  defaultLanguageCode,
  liveTranslationEnabled,
  disabled,
}) => {
  const [error, setError] = useState<string | null>(null)

  const [mutationResult, runMutation]: any[] = useMutation(
    toggleTranslationMutation
  )

  const handleChange = (enable: boolean) => {
    runMutation({ studentSessionId, enable })
      .then(
        result => {
          const { failures } = result.data.studentSessionToggleTranslation
          if (failures.length > 0) {
            setError(failures[0].message)
          } else {
            window.location.reload()
          }
        },
        () => setError("Something went wrong")
      )
      .catch(() => setError("Something went wrong"))
  }

  const languageName = findGeminiLanguage(defaultLanguageCode)?.label

  return (
    <>
      <ul
        className={classNames(
          "list-unstyled min-w-[200px]",
          disabled && "opacity-60"
        )}
      >
        <li className="form-group">
          <div className="form-check">
            <label className="form-check-label">
              Live Translation Enabled
              {languageName && ` (${languageName})`}
              <input
                className="form-check-input"
                type="checkbox"
                checked={liveTranslationEnabled}
                onChange={event => handleChange(event.target.checked)}
                disabled={disabled || mutationResult.fetching}
              />
              <span className="form-check-sign" />
            </label>
          </div>
          {!defaultLanguageCode && (
            <p className="text-sm text-gray-500">
              Set a live translation language on the student to enable this
              option.
            </p>
          )}
        </li>
      </ul>
      {error && <AlertMessageBox>{error}</AlertMessageBox>}
    </>
  )
}

const toggleTranslationMutation = gql`
  mutation AdminStudentSessionToggleTranslation(
    $studentSessionId: ID!
    $enable: Boolean!
  ) {
    studentSessionToggleTranslation(
      studentSessionId: $studentSessionId
      enable: $enable
    ) {
      failures {
        message
      }
    }
  }
`

export default SetTranslationLanguage
